// extracted by mini-css-extract-plugin
export default {"container":"ChatContainer_container__8K200","hidden":"ChatContainer_hidden__XxWFd"};